/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Asset creation request
 */
export interface AssetCreationRequest {
  code: string;
  name: string;
  /**
   * Scale balances in this asset, eg qtyScale = 2 -> step is 0.01
   */
  qtyScale: number;
  /**
   * Disabled asset, can be used only with manual trade registration.
   */
  disabled: boolean;
  /**
   * Reference 1 unit price in USD. Required if manualRate is True
   */
  refUsdPrice?: number;
  /**
   * True if fiat asset. False - by default.
   */
  fiat?: boolean;
  /**
   * False - by default. True if asset rate is setup manually.
   */
  manualRate?: boolean;
}
